export default "__VITE_ASSET__DLTE8Wcg__"